// extracted by mini-css-extract-plugin
export default {"card":"style_card__Kf4z5","imgBox":"style_imgBox__Bjhwr","img":"style_img__eEywf","overlay":"style_overlay__4BJI-","actions":"style_actions__Dvxdh"};